import { render, staticRenderFns } from "./teladv.vue?vue&type=template&id=29c4b476&"
import script from "./teladv.vue?vue&type=script&lang=js&"
export * from "./teladv.vue?vue&type=script&lang=js&"
import style0 from "./teladv.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports